import { useState, useEffect } from "react";
import axiosInstance, { PaginationResponse } from "@/hooks/axios";
import { isAxiosError } from "axios";
import { MembershipType } from "@/types/user";

export interface HookResponse extends PaginationResponse {
  results: MembershipType[];
}

export const useMembershipTypes = () => {
  const [data, setData] = useState<MembershipType[] | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchMembershipTypes = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.get<HookResponse>(
        "users/membership_types/",
      );

      setData(response.data.results);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembershipTypes();
  }, []);

  return { data, loading, error, refetch: fetchMembershipTypes };
};
